// @flow
import api from 'tim-api';
import { accessTracking } from 'endPoints';

type Access = {
  name: string,
  token: string
};

export const state = {
  access: null
};

export const getters = {
  access: ({ access }: Object) => (access && access) || null
};

export const mutations = {
  SET_ACCESS(state: Object, access: Object) {
    state.access = access;
  }
};

export const actions = {
  fetchAccessTracking({ context }: Action, payload: Object) {
    let url = `${accessTracking}`;

    url = `${url}?module=${payload.name}`;

    return api.get(`${url}`);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
